import { FormSelect } from '@systemeio/ui'

type SelectProps = {
  choices: { [key: string]: string }
  update: (value: any) => void
  value: string
}

function Select({ update, choices, value }: SelectProps) {
  return (
    <FormSelect
      data={Object.entries(choices).map(([key, value]) => ({ caption: value, id: key }))}
      onChange={value => update(value)}
      value={value}
      withoutCloseIcon
    />
  )
}

export default Select
